
import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { bounceAnimation, fadeInUp } from './animations';

interface RegistrationButtonProps {
  isInRegistrationProcess: boolean;
}

export const RegistrationButton: React.FC<RegistrationButtonProps> = ({
  isInRegistrationProcess
}) => {
  const scrollToRegistration = () => {
    document.getElementById('registration-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  
  if (isInRegistrationProcess) return null;
  
  return (
    <motion.div 
      initial="hidden" 
      animate="visible" 
      variants={fadeInUp} 
      custom={1} 
      className="mt-2 md:mt-0"
    >
      <Button 
        className="bg-gradient-to-r from-amber-400 to-orange-400 hover:from-amber-500 hover:to-orange-500 text-blue-900 font-medium px-4 md:px-6 py-3 md:py-4 h-auto text-sm md:text-base rounded-lg shadow-lg border-2 border-amber-300 cheerful-button-hover" 
        onClick={scrollToRegistration}
      >
        <span className="mr-1 md:mr-2 font-extrabold text-base md:text-base">Đăng ký ngay</span>
        <motion.div 
          animate={bounceAnimation} 
          className="flex items-center justify-center"
        >
          <ChevronDown className="h-4 w-4 md:h-5 md:w-5" />
        </motion.div>
      </Button>
    </motion.div>
  );
};
